package co.maytes.standupbot.dashboard.features.roster

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.styles.Spacing
import co.maytes.standupbot.shared.dto.standup.LinkStateDto
import co.maytes.standupbot.shared.dto.standup.MemberLinkStatusDto
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.gap

@Composable
fun MemberLinkChips(status: MemberLinkStatusDto, modifier: Modifier = Modifier) {
    Row(
        modifier = Modifier.gap(Spacing.xxs).then(modifier),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        if (status.linear != LinkStateDto.NOT_CONNECTED) LinkStateChip(provider = "Linear", state = status.linear)
        if (status.github != LinkStateDto.NOT_CONNECTED) LinkStateChip(provider = "GitHub", state = status.github)
    }
}
